import './tabanagrafica.css'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Container from 'react-bootstrap/Container'
import { useTranslation } from 'react-i18next';
import PersonalData from './PersonalData';
import ChangePassword from './ChangePassword';
import ProfileManagement from './ProfileManagement';

const TabAnagrafica = () => {
  const { t } = useTranslation(['usersetting']);

  return (
    <Container fluid className='anag-container'>
      <Row>
        <Col sm={7} className='col-left'>
          <Row className='anag-row-header'>
            <Col className='anag-header'>{t('usersetting:tiles.anag')}</Col>
          </Row>
          <Row className='anag-row-field'>
            <Col className='anag-field'><PersonalData /></Col>
          </Row>
        </Col>
        <Col sm={5} className='col-right'>
          <Row className='profile-row-header'>
            <Col className='profile-header'>{t('usersetting:tiles.profile')}</Col>
          </Row>
          <Row className='profile-row-field'>
            <Col className='profile-field'><ProfileManagement /></Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col className='col-password'>
          <Row className='password-row-header'>
            <Col className='password-header'>{t('usersetting:tiles.password')}</Col>
          </Row>
          <Row className='password-row-field'>
            <Col className='password-field'><ChangePassword /></Col>
          </Row>
        </Col>
      </Row>
    </Container >
  );
};

export default TabAnagrafica;